
export interface Request {
    key: string,
    signals: Array<string>
}

export interface QueryRequest {
    requests: Array<Request>,
    startTime: number,
    endTime: number,
    sort: SORT_ORDER
}

export enum SORT_ORDER {
    DESC = 'DESC',
    ASC = 'ASC',
    NONE = ''
}

export enum GetDataRequestStatus {
    Failed = 0,
    NextPage = 1,
    Complete = 2
}

export class GetDataRequestResult {
    public status!: GetDataRequestStatus;
    public transactionId!: string;
    public data: any;
}

export interface Request {
    key: string,
    signals: Array<string>
}

export interface QueryRequest {
    requests: Array<Request>,
    startTime: number,
    endTime: number,
    sort: SORT_ORDER
}